export default __webpack_public_path__ + "531e6768c82258fd3f1b98a1520b9aa1.png";